// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type LocationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.LocationsFilter>;
}>;


export type LocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, name: string, path?: string | null | undefined, displayLocationPath: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string } }> };

export type LocationsSelectField_LocationFragment = { __typename?: 'Location', id: string, name: string, path?: string | null | undefined, displayLocationPath: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string } };

export const LocationsSelectField_LocationFragmentDoc = gql`
    fragment LocationsSelectField_Location on Location {
  id
  name
  path
  displayLocationPath
  type {
    code
    name
  }
}
    `;
export const LocationsDocument = gql`
    query Locations($filter: LocationsFilter) {
  locations(filter: $filter) {
    ...LocationsSelectField_Location
  }
}
    ${LocationsSelectField_LocationFragmentDoc}`;

/**
 * __useLocationsQuery__
 *
 * To run a query within a React component, call `useLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLocationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
      }
export function useLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
// @ts-ignore
export function useLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LocationsQuery, LocationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LocationsQuery, LocationsQueryVariables>;
export function useLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationsQuery, LocationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LocationsQuery | undefined, LocationsQueryVariables>;
export function useLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LocationsQuery, LocationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LocationsQuery, LocationsQueryVariables>(LocationsDocument, options);
        }
export type LocationsQueryHookResult = ReturnType<typeof useLocationsQuery>;
export type LocationsLazyQueryHookResult = ReturnType<typeof useLocationsLazyQuery>;
export type LocationsSuspenseQueryHookResult = ReturnType<typeof useLocationsSuspenseQuery>;
export type LocationsQueryResult = ApolloReactCommon.QueryResult<LocationsQuery, LocationsQueryVariables>;